(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blessing-house-book"] && !Shopify.designMode) return;
  try {
    
  function initializeBlessingHouseAudio(root) {
    root.querySelectorAll('.tbh-audio-player').forEach(function (player) {
      if (player.dataset.initialized === 'true') return;
      player.dataset.initialized = 'true';

      var audio = player.querySelector('.tbh-audio');
      var button = player.querySelector('.tbh-audio-button');
      var icon = player.querySelector('.tbh-audio-icon');
      var label = player.querySelector('.tbh-audio-label');
      var time = player.querySelector('.tbh-audio-time');
      var foreword = player.closest('.tbh-foreword');
      var windowElement = foreword.querySelector('.tbh-foreword-window');
      var scroll = foreword.querySelector('.tbh-foreword-scroll');
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var frame;

      function formatTime(seconds) {
        if (!Number.isFinite(seconds)) return '0:00';
        var minutes = Math.floor(seconds / 60);
        var remaining = Math.floor(seconds % 60).toString().padStart(2, '0');
        return minutes + ':' + remaining;
      }

      function synchronize() {
        var duration = audio.duration;
        var progress = Number.isFinite(duration) && duration > 0 ? audio.currentTime / duration : 0;
        if (!reducedMotion.matches) {
          var distance = Math.max(0, scroll.scrollHeight - windowElement.clientHeight);
          scroll.style.transform = 'translate3d(0,' + (-distance * progress) + 'px,0)';
        }
        time.textContent = formatTime(audio.currentTime) + ' / ' + formatTime(duration);
        if (!audio.paused && !audio.ended) frame = requestAnimationFrame(synchronize);
      }

      function showPlayingState() {
        button.setAttribute('aria-pressed', 'true');
        icon.textContent = 'Ⅱ';
        label.textContent = player.dataset.pauseLabel;
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(synchronize);
      }

      function showPausedState() {
        button.setAttribute('aria-pressed', 'false');
        icon.textContent = '▶';
        label.textContent = audio.currentTime > 0 ? player.dataset.resumeLabel : player.dataset.playLabel;
        cancelAnimationFrame(frame);
        synchronize();
      }

      button.addEventListener('click', function () {
        if (audio.ended) audio.currentTime = 0;
        if (audio.paused) {
          audio.play().catch(showPausedState);
        } else {
          audio.pause();
        }
      });

      audio.addEventListener('loadedmetadata', synchronize);
      audio.addEventListener('play', showPlayingState);
      audio.addEventListener('pause', showPausedState);
      audio.addEventListener('seeked', synchronize);
      audio.addEventListener('ended', function () {
        button.setAttribute('aria-pressed', 'false');
        icon.textContent = '↻';
        label.textContent = player.dataset.replayLabel;
        cancelAnimationFrame(frame);
        synchronize();
      });
    });
  }

  initializeBlessingHouseAudio(document);
  document.addEventListener('shopify:section:load', function (event) {
    initializeBlessingHouseAudio(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
